import { IsVisibleOnGridWithSettingsBaseValueConverter } from 'General/Resources/ValueConverters/IsVisibleOnGridWithSettingsBase';
export class IsVisibleOnGridWithSettingsValueConverter extends IsVisibleOnGridWithSettingsBaseValueConverter {

}